import { createAsyncThunk } from '@reduxjs/toolkit';
import { AddOnProductVariant } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchAddOnProductVariant, FindAddOnProductVariant, GetAddOnProductVariant } from './interface';

export const findAddOnProductVariant = createAsyncThunk(
  'addOnProductVariant/findAddOnProductVariant',
  async (values: FindAddOnProductVariant, { rejectWithValue }) => {
    try {
      const response = await AddOnProductVariant.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createAddOnProductVariant = createAsyncThunk(
  'addOnProductVariant/createAddOnProductVariant',
  async (values: CreatePatchAddOnProductVariant, { rejectWithValue }) => {
    try {
      const response = await AddOnProductVariant.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchAddOnProductVariant = createAsyncThunk(
  'addOnProductVariant/patchAddOnProductVariant',
  async ({ id, ...values }: CreatePatchAddOnProductVariant, { rejectWithValue }) => {
    try {
      const response = await AddOnProductVariant.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getAddOnProductVariant = createAsyncThunk(
  'addOnProductVariant/getAddOnProductVariant',
  async ({ id }: GetAddOnProductVariant, { rejectWithValue }) => {
    try {
      const response = await AddOnProductVariant.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);